import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { AssetTransfer } from '../../models/entities/asset-transfer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { AssetTransferPipe } from '../../pipes/asset-transfer-pipe';
import { Field } from 'src/app/tools/models/dtos/field';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { AssetTransferType } from '../../enums/asset-transfer-type';

@Component({
    selector: 'asset-transfer-list',
    templateUrl: './asset-transfer-list.component.html',
    styleUrls: ['./asset-transfer-list.component.scss']
})


export class AssetTransferListComponent extends BasePage2<AssetTransfer> {

    assetTransferPipe             : AssetTransferPipe = new AssetTransferPipe();

    assetTransferCode : string;
    assetOrderCode    : string;
    startDate         : Date;
    endDate           : Date;
    relatedBranch     : string;
    assetTransferType : string;
    plInitial         : boolean = true;
    plSent            : boolean = true;
    plSemiReceived    : boolean = true;
    plReceived        : boolean = true;

    branchLovComponent = BranchLovComponent;
    
    assetTransfers    : AssetTransfer[] = [];

    sourceBranch      : Branch;
    destinationBranch : Branch;


    constructor(
    private assetTransferService    : AssetTransferService,
    protected toastr                : ToastrService,
    protected router                : Router,
    protected baseService           : BaseService,
    public    leanUtilsService      : LeanUtilsService, 
    protected location              : Location,
    protected activatedRoute        : ActivatedRoute) {
      super(toastr, router, baseService, leanUtilsService, location);
      this.entityName = 'assetTransfer';
    }

//----------------------------------------------------------------------
  ngOnInit(){
    super. ngOnInit();
    this.activatedRoute.data.subscribe(params => {
      this.assetTransferType  = params['assetTransferType'];
  });
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  getRows(): AssetTransfer[] {
      return this.assetTransfers;
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
newAssetTransfer(){
  let assetTransfer : AssetTransfer = new AssetTransfer();

  assetTransfer.assetTransferType = this.assetTransferType;
  assetTransfer.inserted = true;
  assetTransfer.edit     = true;
  this.selectedRow      = assetTransfer;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
 
  let sourceBranchCode      : string = null;
  let destinationBranchCode : string = null;
  let partnerCode : string = null;

  if (this.sourceBranch) sourceBranchCode = this.sourceBranch.branchCode;
  if (this.destinationBranch) destinationBranchCode = this.destinationBranch.branchCode;

  this.assetTransferService.assetTransfersGet(
     this.assetOrderCode,
     sourceBranchCode,
     destinationBranchCode,
     partnerCode,
     this.assetTransferType,
     this.plInitial,
     this.plSent,
     this.plSemiReceived,
     this.plReceived,
     this.startDate,
     this.endDate).then(result => {
      this.assetTransfers = result;
  });
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
selectRow(assetTransfer : AssetTransfer){
  this.assetTransferService.assetTransferGet(assetTransfer.assetTransferCode).then(result => {
    this.selectedRow = result;
  })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  getTitle(){
    if (this.assetTransferType == AssetTransferType.Assignment) {
      return 'Affectations Client';
      } else {
        return 'Transferts Agence';
      }
  }
//----------------------------------------------------------------------
       


//----------------------------------------------------------------------
enrichField(field : Field){
  if (field.prop == 'progressLevel') {
      field.pipe = this.assetTransferPipe;
  }

  if (field.prop == 'partner') {    
    field.modal = PartnerLovComponent;
    field.subProp = 'name';
  }
}
//----------------------------------------------------------------------

    
//----------------------------------------------------------------------
processFields(){
  super.processFields();
  
  let tmp = [];
  if (this.assetTransferType == AssetTransferType.Assignment) {
    this.listFields.forEach(field => { if (field.prop != 'toBranch.name') tmp.push(field);})
  } else {
    this.listFields.forEach(field => { if (field.prop != 'partner.name') tmp.push(field);})
  }
  this.listFields = tmp;

}
//----------------------------------------------------------------------


}
